import { createAsyncThunk } from "@reduxjs/toolkit";
import { postApi } from "../../../services/apiServices";
import {
  CREATE_SUB_ORDER,
  SUB_ORDER_ITEMS,
} from "../../constants/apiConstants";
import Alertify from "../../../services/alertify";

/*---------------- Getting Sub Order Items ---------------- */
export const FetchSubOrderItemsAPI = createAsyncThunk(
  "sub_order_items/admin",
  async (reqData, { rejectWithValue }) => {
    try {
      const response = await postApi(SUB_ORDER_ITEMS, reqData);
      // console.log("Sub Order Items are:", response);
      return response;
    } catch (error) {
      console.error("Error Sub Order Items List API", error);
      // Alertify.error(error.message);
      return rejectWithValue(error); // Throws the error to where dispatch is called
    }
  }
);

/*---------------- Create Sub Order Items ---------------- */
export const CreateSubOrderAPI = createAsyncThunk(
  "sub_order_items/admin",
  async (reqData) => {
    try {
      const response = await postApi(CREATE_SUB_ORDER, reqData);
      // console.log("Create Sub Order:", response);
      return response;
    } catch (error) {
      console.log("Error Create Sub Order List API", error);
      Alertify.error(error.message);
      return Promise.reject(error);
    }
  }
);
